import PageActionContext from "@stores/page-action-context";
import AppDataContext from "@stores/app-data-context";
import React, { useCallback, useContext, useEffect, useState } from "react";
import FormAddressWidget from "./form-address";
import useForm, { buildInput } from "@ui/forms/use-form";
import FormHtmlInput from "@ui/forms/form-input";
import { Checkbox } from "@ui/inputs";

const toAddressForContexStore = (frm) => {
    return {
        unitNumber: frm.values.unitNumber,
        streetNumber: "" + frm.values.streetNumber,
        streetName: frm.values.streetName,
        suburb: frm.values.suburb,
        state: frm.values.state,
        postcode: "" + frm.values.postcode
    };
};

const FormLivingSituation = ({ data }) => {
    
    const [currentAddress, setCurrentAddress] = useState({});
    const [prevAddress, setPrevAddress] = useState({});

    const pageActionCxt = useContext(PageActionContext);
    const appDataCxt = useContext(AppDataContext);
    const cxtData = appDataCxt.getLivingSituation() ?? {};

    const [showPrevAddressForm, setShowPrevAddressForm] = useState(false);

    const form = useForm({
        inputs: [buildInput(data.livingSituation, cxtData?.livingSituation)],
        onSubmit: (values) => {
            console.log(values);
        },
    });
       
    const loadFromContext = () => {
        if (cxtData) {
            setShowPrevAddressForm(cxtData.prevAddress?.streetName ? true : false );
        }
    };
        

    useEffect(() => {
        pageActionCxt.reset();
        loadFromContext();
    }, []);

    const handleSubmit = (e) => {
        e?.preventDefault();

        if (pageActionCxt.isNextDisabled) return;

        if(form.dirty) {
            appDataCxt.setLivingSituation(
                form.values.livingSituation,
                currentAddress,
                showPrevAddressForm ? prevAddress : {}
            );
        } 
        
        var nextEventData = pageActionCxt.nextEventData;

        if (nextEventData) {
            pageActionCxt.navigate(nextEventData.url, nextEventData.isExternal);
        }
    };

    useEffect(() => {
        if (pageActionCxt.isNextClicked) {
            handleSubmit(null);
            pageActionCxt.setNextClicked(false);
        }
    }, [pageActionCxt.isNextClicked]);

    const handleShowPrevAddressClicked = () => {
        setShowPrevAddressForm(!showPrevAddressForm);
    };

    const [isCurrentAddressFormValid, setCurrentAddressFormValid] =
        useState(null);
    const [isPreviousAddressFormValid, setPreviousAddressFormValid] =
        useState(null);
    const handleCurrentAddressformChanged = useCallback((frm) => {
        setCurrentAddressFormValid(frm.isValid);

        if (frm.isValid) {
            setCurrentAddress(toAddressForContexStore(frm));
        }
    });
    const handlePreviousAddressFormChanged = useCallback((frm) => {
        setPreviousAddressFormValid(frm.isValid);
        if (frm.isValid) {
            setPrevAddress(toAddressForContexStore(frm));
        }
    });

    useEffect(() => {
        const isFormValid =
            form.isValid &&
            isCurrentAddressFormValid &&
            (showPrevAddressForm ? isPreviousAddressFormValid : true);
        pageActionCxt.setNextDisabled(!isFormValid);
    }, [
        form.isValid,
        isCurrentAddressFormValid,
        isPreviousAddressFormValid,
        showPrevAddressForm,
    ]);

    return (
        <form name="frm" onSubmit={handleSubmit}>
            <div>
                <FormHtmlInput
                    autoFocus={true}
                    data={data.livingSituation}
                    form={form}
                />
            </div>
            <FormAddressWidget
                name="currentAddress"
                data={data.currentAddress}
                initValues={cxtData?.currentAddress ?? {}}
                onFormStateChanged={handleCurrentAddressformChanged}
            />
            <div className="mt-9">
            <Checkbox
                    name="historyCheckBox"
                    label={data.historyCheckBox}
                    checked = {showPrevAddressForm}
                    onChange={handleShowPrevAddressClicked}
                />
            </div>
            {showPrevAddressForm && (
                <FormAddressWidget
                    name="previousAddress"
                    data={data.previousAddress}
                    initValues={cxtData?.prevAddress ?? {}}
                    onFormStateChanged={handlePreviousAddressFormChanged}
                />
            )}
            <button type="submit" className="hidden">
                Submit
            </button>
        </form>
    );
};

export default FormLivingSituation;
